"use client";
/**
 * Root client providers — wraps the entire app so hooks like useQuery work
 * inside any "use client" island (e.g. SiteHeader → useAllModuleFeaturedFeatures).
 */
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState, type ReactNode } from "react";

export function AppProviders({ children }: { children: ReactNode }) {
  // useState so each browser session gets its own QueryClient (not a module singleton)
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 min
            retry: 1,
          },
        },
      })
  );

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
